module.exports = __webpack_public_path__ + "img/1219.9689ca76.gif";